export const NULL_BARCODE_STATUS = 'Null';

// Add the remaining officially approved values here when supplied.
export const BARCODE_STATUS_OPTIONS = [
	{ value: 'Barcode Available', label: 'Attached' },
	{ value: 'Barcode Pending', label: 'Missing' },
	{ value: NULL_BARCODE_STATUS, label: 'No Barcode' },
] as const;

const NO_BARCODE_TEAMS: Record<string, string[]> = {
	axs: [
		'Houston Rockets',
		'Los Angeles Kings',
		'FC Dallas',
		'LA Galaxy',
		'Dallas Wings',
		'Las Vegas Aces',
		'Los Angeles Sparks',
		'Minnesota Lynx',
	],
	tixr: ['Houston Dynamo FC'],
};

const normalize = (value: unknown): string =>
	String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');

export function getAutomaticBarcodeStatus(
	eventName: unknown,
	row: unknown,
	platform?: unknown,
): typeof NULL_BARCODE_STATUS | null {
	const normalizedEventName = normalize(eventName);
	const normalizedPlatform = normalize(platform);
	const teams = normalizedPlatform
		? NO_BARCODE_TEAMS[normalizedPlatform] || []
		: Object.values(NO_BARCODE_TEAMS).flat();
	const teamMatches = teams.some((team) =>
		normalizedEventName.includes(normalize(team)),
	);
	const isParkingRow = normalize(row).includes('park');

	return teamMatches || isParkingRow ? NULL_BARCODE_STATUS : null;
}
